export const NUMBER_OF_CARD_SKELETON_ITEMS = 8;
export const NUMBER_OF_COLUMNS_SMALL = 1;
export const NUMBER_OF_COLUMNS_CONFINED = 3;
export const NUMBER_OF_COLUMNS_DEFAULT = 4;
